export default "__VITE_ASSET__n9naNW2G__"